<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM10 15.5002V8.50018C10 8.09018 10.47 7.85018 10.8 8.10018L15.47 11.6002C15.74 11.8002 15.74 12.2002 15.47 12.4002L10.8 15.9002C10.47 16.1502 10 15.9102 10 15.5002Z"
  />
</template>
